import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import {
  get_module_entity_action_middleware,
  put_module_entity_action_middleware,
  delete_module_entity_action_middleware,
} from "services/middleware_services"
import Swal from "sweetalert2"

interface IGetChannelParams {
  channel_id: string
  params?: any
}

interface IPostChannelParams {
  body: any
}

const useChannelsResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const get_channel_action = async ({ channel_id, params = {} }: IGetChannelParams) => {
    try {
      return await get_module_entity_action_middleware(
        OMNIX_MODULE.OIM,
        `inventory/channel/${channel_id}`,
        params,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const post_list_channel_action = async () => {
    try {
      return await get_module_entity_action_middleware(OMNIX_MODULE.OIM, `inventory/channel`, {}, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const put_upsert_channel_action = async ({ body }: IPostChannelParams) => {
    try {
      return await put_module_entity_action_middleware(OMNIX_MODULE.OIM, `inventory/channel`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const delete_channel_action = async ({ id }: any) => {
    try {
      return await delete_module_entity_action_middleware(OMNIX_MODULE.OIM, `inventory/channel/${id}`, {}, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    get_channel_action,
    post_list_channel_action,
    put_upsert_channel_action,
    delete_channel_action,
    loading_app,
    set_loading_app,
  }
}

export default useChannelsResources
